import React, { useState, useContext } from 'react';
import { DateContext } from './DateContext';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';

const DateFilter = () => {
  const { setWithinDate } = useContext(DateContext);
  const [selected, setSelected] = useState('past1days');

  const options = [
    { label: 'Today', value: 'thisday' },
    { label: 'Yesterday', value: 'past1days' },
    { label: 'Last Week', value: 'past1weeks' },
    { label: 'Last 7 Days', value: 'past7days' },
    { label: 'Last 30 Days', value: 'past30days' },
  ];

  const handleChange = (event) => {
    const val = event.target.value;
    setSelected(val);
    setWithinDate(val);
  };

  return (
    <Box className="date-filter-container">
  <Typography variant="subtitle2" className="date-filter-label">
         
  </Typography>
  <FormControl fullWidth size="small" variant="outlined">
    <InputLabel id="within-date-label" className="date-filter-input-label">
      Within Date
    </InputLabel>
    <Select
      labelId="within-date-label"
      value={selected}
      label="Within Date"
      onChange={handleChange}
      className="date-filter-select"
      MenuProps={{
        PaperProps: {
          style: {
            zIndex: 1300,
          },
        },
      }}
    >
      {options.map((option, idx) => (
        <MenuItem key={idx} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>
  );
};

export default DateFilter;
